import { ButtonBase, lighten, ListItem, styled } from "@mui/material";
import { scrollbarStyle } from "styles/global-styles";
import { exProps } from "utils/mui";

export const Column = styled('div')(({ theme }) => ({
  flexGrow: 1,
  flexBasis: 300,
  overflow: "auto",
  ...scrollbarStyle
}))

export const Header = styled('div')(({ theme }) => ({
  display: "flex",
  alignItems: "center"
}))

export const ProjectsContainer = styled('div')(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  rowGap: theme.spacing(3),
  columnGap: theme.spacing(4),
}))

export const ProjectItem = styled(ButtonBase, exProps('selected'))<{ selected?: boolean }>(({ theme, selected }) => ({
  backgroundColor: theme.palette.background.paper,
  boxShadow: `0px 2px 10px rgba(0, 0, 0, 0.2)`,
  height: 100,
  boxSizing: "border-box",
  borderRadius: theme.shape.borderRadius,
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  justifyContent: "space-between",
  paddingLeft: theme.spacing(3),
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  textAlign: "left",
  border: `1px solid transparent`,
  ...selected && {
    borderColor: theme.palette.primary.main
  }
}))

export const SchemaListItem = styled(ListItem)(({ theme }) => ({
  height: 56,
  ".show-on-hover": {
    opacity: 0
  },
  "&:hover": {
    cursor: "pointer",
    backgroundColor: lighten(theme.palette.background.paper, 0.02),
    ".show-on-hover": {
      opacity: 1
    },
  }
}))